window.app = window.app || {};

(function($) {

	formHelper.addIPeerRule({
		// ID of the Payment form on the WWW site
		// No need to call out the form id inside the iframe
		// The selector 'form' is always used
		form: '#manualBookStep1Info',
		status: {
			// SUCCESS is what we would do if BOTH the iframe cde
			// and the www forms are successful
			SUCCESS: '/rci_admin/manual_booking_tool/step_2',
			SESSION_EXPIRED: '/rci_admin/manage_customers'
			}
	});

	formHelper.addRule({
		form: '#manualBookStep1InfoNoPayment',
		status: {
			SUCCESS: '/rci_admin/manual_booking_tool/step_2'
		},
		xhrReady: function(xhrOptions) {
			xhrOptions.data['peer-status'] = 'SUCCESS';
		}
	});

})(jQuery);

jQuery(function($) {

	$('.js-manual-booking-unit-cost').blur(function(event){
		formHelper.portholeSendFHIPeerCustomEvent({"event":"toolsunitcostchange","unitCost":$(this).val()});
	});

	$('.fh-js-manualBookStep1Info-submitter').on('click',function(event){
		$('#manualBookStep1Info, #manualBookStep1InfoNoPayment').submit();
	});
});

